import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Grid, Row, Col } from 'react-flexbox-grid';
import { ThemeProvider } from '@material-ui/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import theme from '../theme';

import './LoginLayout.scss';

class LoginLayout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
  };

  componentDidMount() {
    document.body.classList.add('login');

    document.addEventListener('gesturestart', function (e) {
      e.preventDefault();
    });

    document.addEventListener('touchmove', function(event) {
      event = event.originalEvent || event;
      if(event.scale > 1) {
        event.preventDefault();
      }
    }, false);

  }

  componentWillUnmount() {
    document.body.classList.remove('login');
  }

  render() {
    const { children, title } = this.props;

    return (
      <ThemeProvider theme={theme}>
        <Grid fluid>
          <Row center='xs'>
            <Col xs={12} sm={8} md={6} lg={4}>
              <Card>
                <CardContent>
                  <Typography variant="h5">{title}</Typography>

                  {children && children}
                </CardContent>
              </Card>
            </Col>
          </Row>
        </Grid>
      </ThemeProvider>
    );
  }
}

export default LoginLayout;
